import React, { useState } from "react";
import { useQuery } from "react-query";
import { Col, Container, Row } from "reactstrap";
import { HeaderSection } from "../../components/shared/HeaderSection";
import { CardTouristic } from "../../components/tourism/CardTouristic";

import ROUTES from "../../routes/routes";
import { getTouristServers } from "../../services/tourismService";
import { LoadMoreButtons } from "../../components/tourism/LoadMoreButtons";
import { Search } from "react-feather";
import { TouristSearch } from "../../components/tourism/TouristSearch";

const Servers = () => {
  const [activateSearch, setActivateSearch] = useState(false);
  const [newUrl, setNewUrl] = useState(null);

  const colorServers = "#1BADE1";

  const { isLoading, isError, data, isFetching } = useQuery(
    ["servers", newUrl],
    () => getTouristServers(newUrl),
    { keepPreviousData: true }
  );

  if (isLoading) return <p>Cargando</p>;
  if (isFetching) return <p>Loading feaching...</p>;
  if (isError) return <p>Error</p>;

  return (
    <>
      <HeaderSection
        route={ROUTES.TOURISM}
        resume={"Volver a Turismo"}
        bgBtnColor={colorServers}
      />
      <Container>
        <Row>
          <Col md="9">
            <h3
              className="subheader-main"
              style={{ borderColor: colorServers }}
            >
              Servidores Turísticos
            </h3>
          </Col>
          <Col md="3" style={{ textAlign: "right", paddingTop: "2em" }}>
            <Search
              size={32}
              color={colorServers}
              onClick={() => setActivateSearch(true)}
            />
          </Col>
        </Row>
        {activateSearch ? (
          <TouristSearch
            stateUrl={setNewUrl}
            stateActivateSearch={setActivateSearch}
          />
        ) : null}
        <CardTouristic
          data={data.results}
          routeDetail={ROUTES.SERVER_DETAIL}
          bgBtnColor={colorServers}
        />
        <LoadMoreButtons
          setUrl={setNewUrl}
          previous={data.previous}
          next={data.next}
        />
      </Container>
      <HeaderSection
        route={ROUTES.TOURISM}
        resume={"Volver a Turismo"}
        bgBtnColor={colorServers}
      />
    </>
  );
};

export default Servers;
